<template>
  <ListItemsWithTableLayout>
    <template #body>
      <HandlerAccessDenied :is-denied="isDenied">
        <AdsCabinetFilterForm
          :isFilterEnabled="isFilterEnabled"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
          @set-filter="setFilter"
        ></AdsCabinetFilterForm>
        <TopListAdsCabinetsPanel
          @set-common-filter="setCommonFilter"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
          :isFilterEnabled="isFilterEnabled"
          :isFilterSetted="isFilterSetted"
        ></TopListAdsCabinetsPanel>
        <div
          id="table-container"
          class="table-container flex flex-col"
          :class="[
            filteredAdsCabinets && filteredAdsCabinets.length == 0
              ? 'empty'
              : 'filled',
          ]"
        >
          <AdsCabinetsTable
            :ads-cabinets="filteredAdsCabinets"
            :isActiveFirst="activeFirstFromStore"
            :isLoading="isLoading"
            :rowsCount="rowsCount(43) * tableDisplaySettings.first"
            @sort-table="sortTable"
            @update-table="updateAdsCabinetsList"
          ></AdsCabinetsTable>
          <EmptyTableMessage
            v-if="
              filteredAdsCabinets &&
              filteredAdsCabinets.length == 0 &&
              !isLoading
            "
          >
            <template #text>
              Примените другой фильтр или создайте первый кабинет. <br />
              Для этого кликните на кнопку "Создать рекламный кабинет".
            </template>
          </EmptyTableMessage>
        </div>
        <Paginator
          v-model:first="tableDisplaySettings.first"
          @update:first="updateAdsCabinetsList"
          :rows="1"
          class="s-paginator"
          :totalRecords="store.adsCabinetsPagesCount"
          template="PrevPageLink CurrentPageReport NextPageLink"
          currentPageReportTemplate="{first} из {totalRecords}"
        />
      </HandlerAccessDenied>
    </template>
  </ListItemsWithTableLayout>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";

import Paginator from "primevue/paginator";
import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import TopListAdsCabinetsPanel from "@/entities/dictionaries/ads_cabinets/panels/TopListAdsCabinetsPanel.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import AdsCabinetsTable from "@/entities/dictionaries/ads_cabinets/AdsCabinetsTable.vue";
import AdsCabinetFilterForm from "@/entities/dictionaries/ads_cabinets/forms/AdsCabinetFilterForm.vue";

import {
  useAdsCabinetsStore,
  AdsCabinetsParams,
} from "@/store/dictionaries/ads_cabinets";
import { useAuthStore } from "@/store/auth/login";
import { rowsCount } from "@/services/utils/Pagination";
import { setAdsCabinetsParamsByFilter } from "@/services/dictionaries/ads_cabinets";
import { FilterForm } from "@/services/dictionaries/ads_cabinets";

const store = useAdsCabinetsStore();
const authStore = useAuthStore();
const isLoading = ref(false);
const isFilterEnabled = ref(false);
const isFilterSetted = ref(false);
const tableDisplaySettings = ref({
  first: 0,
  orderField: "",
  commonFilter: "",
  filter: {} as FilterForm,
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["dictionaries:read", "dictionaries:edit"]
  );
});

const filteredAdsCabinets = computed(() => {
  return store.adsCabinetsList;
});

const activeFirstFromStore = computed(() => store.activeFirst);

onMounted(() => {
  loadData();
});

const loadData = () => {
  isLoading.value = true;
  updateAdsCabinetsList();
};

const setCommonFilter = (filter: string) => {
  tableDisplaySettings.value.commonFilter = filter;
  updateAdsCabinetsList();
};

const sortTable = (order_by: string) => {
  tableDisplaySettings.value.orderField = order_by;
  updateAdsCabinetsList();
};

const setFilter = (filter: FilterForm, isSetted: boolean) => {
  tableDisplaySettings.value.filter = filter;
  isFilterSetted.value = isSetted;
  updateAdsCabinetsList();
};

const updateAdsCabinetsList = () => {
  let isEnded = false;
  setTimeout(() => {
    if (!isEnded) {
      isLoading.value = true;
    }
  }, 200);
  const params: AdsCabinetsParams = {
    page: tableDisplaySettings.value.first + 1,
    per_page: rowsCount(43),
  };

  setAdsCabinetsParamsByFilter(params, tableDisplaySettings.value);

  store.getAdsCabinets(params).finally(() => {
    isLoading.value = false;
    isEnded = true;
  });
};

let resizeTimeout: number;

window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateAdsCabinetsList, 200);
});
</script>
